import React, { useEffect, useState } from 'react';
import { Table, Pagination, Select } from "antd";
import { t } from "i18next";
import CustomPaging from '../pagination/pagination';

export default function CustomTable(props) {
    const [total, setTotal] = useState(props?.total)
    const [isLoaded, setIsLoaded] = useState(false)
    

    useEffect(() => {
        if (props?.total !== undefined) {
            setIsLoaded(true)
        }
    }, [props?.total])

    return (
        <div>
            <Table columns={props.columns} rowClassName={props.rowClassName} onRow={props.onRow} dataSource={props.data} pagination={false} scroll={props.scroll} summary={props.summary}/>
            <div className={props.isnotPaging ? "":"h-11 flex items-center justify-end bg-[#EAEAEA] border-t-[#EAEAEA] border-solid rounded-b-xl px-[30px] py-[8px]"}>

                {
                    props.showPagination && isLoaded ? (
                        <div className='flex items-center justify-end'>
                            <p>{t("USER:VIEW_PER_PAGE")}</p>

                            <div className='mx-[8px] '>
                                <Select
                                    value={props.pageLimit}
                                    style={{ width: 49 }}
                                    onChange={(value) => props.onChange(1, value)}
                                    options={[
                                        { value: 10, label: 10 },
                                        { value: 20, label: 20 },
                                        { value: 50, label: 50 },
                                        { value: 100, label: 100 },
                                    ]}
                                />
                            </div>

                            <Pagination defaultCurrent={1} current={props.currentPage ? props.currentPage : null} pageSize={props.pageLimit} onChange={(page) => props.onChange(page, props.pageLimit)} showSizeChanger={false} total={props.total} />
                        </div>
                    ) : null
                }
            </div>
        </div>
    );
}